import { render, staticRenderFns } from "./CaseTasklist.vue?vue&type=template&id=00ddce96"
import script from "./CaseTasklist.vue?vue&type=script&lang=js"
export * from "./CaseTasklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports